import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as LogoImg } from '../../../assets/svg/MIAuto_HorizontalSingleLineOnWhite.svg';
import { ActionLink, Button, ModalWindow } from '../../atoms';
import './dashboard-header.scss';
import { default as t } from '../../../utils/i18n';
import config from '../../../utils/config';
import { UserContext } from '../../../context';
import { useHistory } from 'react-router-dom';
import { Popover, Whisper } from 'rsuite';
import fileDownload from 'js-file-download';
import axios from '../../../utils/axios';
import axiosStat from 'axios';

const HELP_SUPPORT_LINK = config.get('help', 'support_link');
const HELP_EMAIL_ID = config.get('help', 'support_email');
const HELP_LINK = config.get('help', 'support_url');
const HELP_SUPPORT_LINK_PERF = config.get('help', 'support_link_performance');


const DashboardHeader = () => {
  const { user, setUser  } = useContext(UserContext);
  const history = useHistory();
  const [showCancelModal, setShowCancelModal] = useState(false);

  const handlebackOnInterstitlial = () => {
    if (history?.location?.pathname !== '/define-report') {
      history.push('/interstitial');
    } else {
      setShowCancelModal(true);
    }
  };

  const handleOnCloseCancelModal = () => {
    setShowCancelModal(false);
  };

  const onContinue = e => {
    e.preventDefault();
    setShowCancelModal(false);
    history.push('/interstitial');
  };

  const onCancelReq = () => {
    setShowCancelModal(false);
  };

  const handleDownload = (url, filename) => {
    const userGuideUrl = url.replace(/\{(.*?)\}/gi, t('dashboard.link.helpAndSupport', true));
    const api = axiosStat.create({
      baseURL: axios.defaults.baseURL.slice(0, -4),
    });
    api
      .get(userGuideUrl, {
        responseType: 'blob',
      })
      .then(res => {
        fileDownload(res.data, filename);
      });
  };

  const speaker = (
    <Popover style={{ width: 200 }}>
      <div>
        <span className="help-pdf-3">{t('download.pdf.info.question')}</span>
        <button
          onClick={() => {
            handleDownload(HELP_SUPPORT_LINK_PERF, 'help.pdf');
          }}
          className="download-pdf-3"
        >
          <i className="eva eva-message-circle-outline"></i>
          {t('download.pdf.button.label')}
        </button>
      </div>
    </Popover>
  );

  const handleBackToUPA = () =>{
    window.location.replace(`${process.env.REACT_APP_UPA_BASE_URL}/overview`)
  }

  const handleSignOut = () => {
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    setUser(null);
    setTimeout(() => {
      window.location.href =  `${process.env.REACT_APP_UPA_BASE_URL}/signout`
    }, 100);
  }

  return (
    <div className="c-dashboardlogo">
      <div className="c-dashboardlogo--box">
        <LogoImg className="c-dashboardlogo--image" onClick={() => handlebackOnInterstitlial()} />
          
        <div className="c-dashboardlogo--action-holder">
          {user && user.name && (
            <label className="c-business--label c-text-heading-2">
              <i className="fas fa-user"></i>
              {user.name}
            </label>
          )}
           <a className="c-business--label-bold logout" onClick={handleBackToUPA}>
            {t('Back To OneSocial')}
          </a>
          <a className="c-business--label-bold logout" onClick={handleSignOut}>
            {t('dashboard.nav.header.link.signOut')}
          </a>
         { (history?.location?.pathname === '/define-report' || history?.location?.pathname === '/report-output' || history?.location?.pathname === '/reports' )&& <Whisper preventOverflow trigger="click" speaker={speaker} placement="bottom">
            <i className="eva eva-question-mark-circle c-help"></i>
          </Whisper>}
          {/* <ActionLink
        styleClass={'help'}
          anchor={true}
          href={HELP_SUPPORT_LINK.replace(/\{(.*?)\}/gi,t('dashboard.link.helpAndSupport',true))}
          value={t('dashboard.link.helpAndSupport')}
          icon={true}
        /> */}
          <ActionLink
            styleClass={'email'}
            anchor={true}
            href={HELP_LINK}
            value={t('dashboard.link.emailus')}
            icon={true}
          ></ActionLink>
        </div>
      </div>
      <div className="report-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showCancelModal}
          onRequestClose={handleOnCloseCancelModal}
          heading={t('define.stepper.cancel.heading')}
        >
          <p className="fqa-model-showanswer--message message-font">
            {t('define.stepper.cancel.subHeading')}
          </p>
          <p></p>
          <div className="fqa-model-pa--actions action-items">
            <ActionLink anchor={true} value={t('define.stepper.yes')} handleClick={onContinue} />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              label={t('define.stepper.no')}
              handleClick={onCancelReq}
            />
          </div>
        </ModalWindow>
      </div>
    </div>
  );
};

export default DashboardHeader;
